import * as React from "react";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { inject } from "mobx-react";

import { AnalyticsConfig } from "uitk-react-utils";
import { UitkBreadcrumbs } from "uitk-react-breadcrumbs";

import { CrossLOBMenu } from "components/flexComponents/Breadcrumbs/components/CrossLOBMenu";
import {
  Action,
  FlexTrackingInfo,
  sendDelayedTrackEvent
} from "components/utility/analytics/FlexAnalyticsUtils";

import { BreadcrumbsProps } from "./typings";

export const Breadcrumbs = inject("analytics")((props: BreadcrumbsProps) => {
  const { flexComponent } = props;
  const model = flexComponent && flexComponent.model;
  const breadcrumbs = model && model.breadcrumbs;

  if (!model || model.empty || !breadcrumbs) {
    return null;
  }

  const [isBreadcrumbsMenuOpen, setBreadcrumbsMenuOpen] = React.useState(false);

  const onBreadcrumbsMenuTriggerClick = () => {
    setBreadcrumbsMenuOpen(!isBreadcrumbsMenuOpen);
  };

  // add analytics to the breadcrumbs for tracking
  const breadcrumbsWithAnalytics = breadcrumbs.map(crumb => {
    const analytics: AnalyticsConfig = {
      id: "breadcrumbs",
      callback: (id, description) => {
        const flexTrackingInfo: FlexTrackingInfo = {
          moduleName: id,
          action: Action.CLICK,
          linkName: description
        };
        sendDelayedTrackEvent(flexTrackingInfo, props.analytics);
      }
    };

    return {
      text: crumb.text,
      url: crumb.url,
      analytics
    };
  });

  const menuAnalytics: AnalyticsConfig = {
    id: "breadcrumbs.menu",
    callback: (id, description) => {
      const flexTrackingInfo: FlexTrackingInfo = {
        moduleName: id,
        action: Action.CLICK,
        linkName: description
      };
      sendDelayedTrackEvent(flexTrackingInfo, props.analytics);
    }
  };

  // find the first breadcrumbs with the dropdown, will be used for the dropdown Plan your trip menu
  const breadcrumbsDropdown = breadcrumbs.find(crumb => !!crumb.dropDown);

  const viewClass = model.view || "";
  const mainClass = `Breadcrumbs ${viewClass} uitk-cell all-cell-1-1 uitk-flex uitk-flex-justify-content-space-between uitk-flex-align-items-center all-y-padding-one`;

  return (
    <div
      className={mainClass}
      id={flexComponent.id}
      data-fm={flexComponent.fmId}
      data-fm-title-id={flexComponent.fmTitleId}
    >
      <Viewport>
        <ViewSmall>
          <UitkBreadcrumbs
            crumbs={breadcrumbsWithAnalytics}
            crumbsToDisplay={1}
            isOpen={isBreadcrumbsMenuOpen}
            menuAnalytics={menuAnalytics}
            onTriggerClick={onBreadcrumbsMenuTriggerClick}
          />
        </ViewSmall>

        <ViewMedium>
          <UitkBreadcrumbs crumbs={breadcrumbsWithAnalytics} className="all-y-padding-two" />
        </ViewMedium>
      </Viewport>

      {breadcrumbsDropdown && (
        <CrossLOBMenu items={breadcrumbsDropdown.dropDown} analyticsStore={props.analytics} />
      )}
    </div>
  );
});

export default Breadcrumbs;
